import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Alert, Divider, Checkbox } from 'antd';
import { loginUser } from '../api';
import { useNavigate, Link } from 'react-router-dom';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from './AuthContext';

const { Title, Text } = Typography;

const Login = () => {
  const [form] = Form.useForm();
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const { email, password } = values;
      const data = await loginUser(email, password);

      if (data.success && data.token) {
        localStorage.setItem('token', data.token);
        setUser(data.user);
        setSuccessMessage(data.message || 'Вход выполнен успешно!');
        setErrorMessage('');
        setTimeout(() => navigate('/dashboard'), 1000);
      } else {
        setErrorMessage(data.message || 'Неверные данные. Попробуйте снова.');
        setSuccessMessage('');
      }
    } catch (error) {
      setErrorMessage(error?.message || 'Ошибка сервера. Повторите позже.');
      setSuccessMessage('');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #e0f7fa 0%, #f9fbe7 100%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2rem',
      }}
    >
      <Card
        style={{
          maxWidth: 420,
          width: '100%',
          borderRadius: 16,
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
          background: 'white',
          padding: '2rem 2.5rem',
          animation: 'fadeIn 0.5s ease-in-out',
        }}
        bordered={false}
      >
        <Title level={2} style={{ textAlign: 'center', marginBottom: 8 }}>
          Добро пожаловать
        </Title>
        <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: 24 }}>
          Пожалуйста, войдите в свой аккаунт
        </Text>

        {successMessage && (
          <Alert message={successMessage} type="success" showIcon style={{ marginBottom: 16 }} />
        )}
        {errorMessage && (
          <Alert message={errorMessage} type="error" showIcon style={{ marginBottom: 16 }} />
        )}

        <Form form={form} onFinish={onFinish} layout="vertical" requiredMark={false}>
          <Form.Item
            label="Электронная почта"
            name="email"
            rules={[{ required: true, message: 'Введите вашу почту' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="name@example.com"
              size="large"
              allowClear
              style={{ borderRadius: 8 }}
            />
          </Form.Item>

          <Form.Item
            label="Пароль"
            name="password"
            rules={[{ required: true, message: 'Введите пароль' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Введите пароль"
              size="large"
              allowClear
              style={{ borderRadius: 8 }}
            />
          </Form.Item>

          <Form.Item>
            <Checkbox defaultChecked>Запомнить меня</Checkbox>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              loading={loading}
              style={{ borderRadius: 8 }}
            >
              Войти
            </Button>
          </Form.Item>

          <Divider />

          <div style={{ textAlign: 'center' }}>
            <Text>Нет аккаунта? <Link to="/register">Зарегистрироваться</Link></Text>
            <br />
            <Link to="/recover-password" style={{ fontSize: 13, display: 'inline-block', marginTop: 8 }}>
              Забыли пароль?
            </Link>
          </div>
        </Form>
      </Card>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default Login;
